import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { "data-supporters-list": "" };
const _hoisted_2 = {
    key: 0,
    class: "w-full font-sans text-sm font-light"
};
const _hoisted_3 = ["href", "target", "rel"];
import ImageLandscape from '@scripts/components/atoms/ImageLandscape.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SupportersListBlock',
    props: {
        useContainer: { type: Boolean },
        title: {},
        items: {},
        verticalAlignment: {}
    },
    setup(__props) {
        const getImageClasses = (sizeChoice) => {
            const classes = '!w-auto h-auto';
            if (sizeChoice === 'small') {
                return `${classes} max-h-20`;
            }
            if (sizeChoice === 'large') {
                return `${classes} max-h-36`;
            }
            //default to medium
            return `${classes} max-h-28`;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _createElementVNode("div", {
                    class: _normalizeClass(["flex flex-col", {
                            container: _ctx.useContainer,
                        }])
                }, [
                    (_ctx.title)
                        ? (_openBlock(), _createElementBlock("h2", _hoisted_2, _toDisplayString(_ctx.title), 1))
                        : _createCommentVNode("", true),
                    (_ctx.items && _ctx.items.length > 0)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: _normalizeClass(["flex w-full flex-wrap gap-5 lg:justify-start", {
                                    'items-start': _ctx.verticalAlignment === 'top',
                                    'items-center': _ctx.verticalAlignment === 'center',
                                    'items-end': _ctx.verticalAlignment === 'bottom',
                                }])
                        }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
                                return (_openBlock(), _createElementBlock(_Fragment, null, [
                                    (item.link.url)
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 0,
                                            href: item.link.url,
                                            class: "group",
                                            target: item.link.target,
                                            rel: item.link.target === '_blank'
                                                ? 'noopener noreferrer'
                                                : null
                                        }, [
                                            _createVNode(ImageLandscape, {
                                                forcedRatio: false,
                                                image: item.image,
                                                imageClasses: getImageClasses(item.imageSize),
                                                class: "w-fit"
                                            }, null, 8, ["image", "imageClasses"])
                                        ], 8, _hoisted_3))
                                        : (_openBlock(), _createBlock(ImageLandscape, {
                                            key: 1,
                                            forcedRatio: false,
                                            image: item.image,
                                            imageClasses: getImageClasses(item.imageSize),
                                            class: "w-fit"
                                        }, null, 8, ["image", "imageClasses"]))
                                ], 64));
                            }), 256))
                        ], 2))
                        : _createCommentVNode("", true)
                ], 2)
            ]));
        };
    }
});
